import '../containerStyles.css';
import { getImagePaths, loadImages } from '../utils/imageLoader';
import imageConfig from "../config/json/imageConfig.json";
import React, { useState, useRef, useEffect} from 'react';
import { SoundProvider, useSound } from '../components/sound/soundContext';

const AboutPage = ({ theme, onBackClick }) => {
  const [isMouseOverPhoto, setIsMouseOverPhoto] = useState(false);
  const [meImage, setMeImage] = useState(null);
  const {playPopSound}= useSound();
  
  //Load images on component mount
  useEffect(() => {
    const loadMeImages = async () => {
      try {
        const images = await loadImages('mePhoto');
        const mappedImages = {};
        const meKeys = Object.keys(imageConfig.mePhoto);
        
        images.forEach((imgModule, index) => {
          mappedImages[meKeys[index]] = imgModule;
        });
        setMeImage(mappedImages);
      } catch (error) {
        console.error("Error loading images:", error);
      }
    };
    
    loadMeImages();
  }, []);
  
  //Get the appropriate image based on theme and hover state
  const getCurrentImage = () => {
    if (!meImage) return null;
    
    if (isMouseOverPhoto) {
      return meImage.photo;
    }
    return theme === 'light' ? meImage.day : meImage.night;
  };

  return (
    <div className='aboutPage'>
      {meImage && (
        <div className="about-photo-container">
          <img 
            src={getCurrentImage()} 
            alt="Anh Nguyen"
            className="about-photo"
            onMouseEnter={() => setIsMouseOverPhoto(true)}
            onMouseLeave={() => setIsMouseOverPhoto(false)}
            onClick={() => playPopSound()}
          />
        </div>
      )}
      <div className="about-header">
        <h3>Vi-Anh Nguyen</h3>
        <h4>TX based freelance illustrator, pixel animator and web developer</h4>
      </div>
      <div className="info-container">
        <p>Hello! I'm Anh! I'm an illustrator, and web developer. I ...</p>
        <ul>
          <li>create both digital and traditional illustrations,</li>
          <li>do frontend development,</li>
          <li>make games,</li>
          <li>and create pixel animations,</li>
        </ul>
        <h4>Education</h4>
        <p>Bachelor of Arts in Animation (Graduated 2018)</p>
        <p>Master's of Science in Computer Science (Graduated 2023)</p>
      </div>
      <br/>
      <p>This whole endeavor, along with my funky little rabbit mascot, 
        started as a way to present myself to others through the things 
        I create. I asked myself, how do I want others to see me and my work?
        And this is how everything came about!</p>
    </div>
  );
};

export default AboutPage;